import React, {PureComponent} from "react"
import {FormattedMessage} from "@irati/utils/lang"

import Form from "@irati/ui/src/Form"
import {Checkbox} from "@irati/ui/src/FormItem"
import {Label} from "@irati/ui/src/Typography"
import {User as UserType, Team} from "@irati/types"

import authentication from "@irati/auth"
import {canModifyUserMembership} from "@irati/identity/utils/team/membership"
import User from "../../Users/User/index"

interface Props {
  user: UserType
  selectedEmployees: UserType[]
  currentTeam: Team
  updateSelectedUser: (user: UserType) => void
}

export default class AddUserToTeamUserRow extends PureComponent<Props> {
  userAlreadyInTeam = (user: UserType) => {
    const {currentTeam} = this.props
    return user.teamIds.find((teamId) => teamId === currentTeam.uuid)
  }

  action = (user: UserType) => {
    const {updateSelectedUser, selectedEmployees} = this.props

    if (this.userAlreadyInTeam(user)) {
      return (
        <Label weight="bold">
          <FormattedMessage id="admin.components.addUserToTeamUserRow.labelOne" />
        </Label>
      )
    } else if (canModifyUserMembership(this.props.currentTeam, authentication.user(), user)) {
      return (
        <Form>
          <Checkbox
            name={user.uuid}
            className="pull-right"
            checked={!!selectedEmployees.find((selectedEmployee) => selectedEmployee.uuid === user.uuid)}
            onChange={() => updateSelectedUser(user)}
          />
        </Form>
      )
    }

    return null
  }

  render() {
    const {user} = this.props

    return <User user={user} rowData={user.email} lowercaseRowData showCheckbox={false} action={this.action(user)} />
  }
}
